import { render } from "./view.vue?vue&type=template&id=c4cfa77c&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=c4cfa77c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\FAUZAN\\Documents\\Project\\ore-no-app-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cfa77c"]])

export default __exports__